module.exports = __webpack_public_path__ + "static/img/10.ada052a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/sp/10.png
// module id = ihZC
// module chunks = 0